import React, { useEffect, useState } from "react";
import { Route, Switch, Redirect, useLocation, Link } from "react-router-dom";
//locall
import { storage } from "../utils";
import { useAppContext } from "../context/state";
// routes
import { Home } from "./home/Home";
import { SignIn } from "./signIn/SignIn";
import { AddProduct } from "./addProduct/AddProduct";
import { ShowProducts } from "./showProducts/ShowProducts";
//styles
import "../assets/vendors/css/vendors.min.css";
import "../assets/vendors/css/charts/apexcharts.css";
import "../assets/vendors/css/extensions/swiper.min.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/bootstrap-extended.css";
import "../assets/css/colors.css";
import "../assets/css/components.css";
import "../assets/css/themes/dark-layout.css";
import "../assets/css/themes/semi-dark-layout.css";
import "../assets/css/core/menu/menu-types/vertical-menu.css";
import "../assets/css/pages/dashboard-ecommerce.css";
import "../assets/vendors/css/tables/datatable/datatables.min.css";
import "../assets/css/plugins/forms/wizard.css";
import "../assets/vendors/css/charts/apexcharts.css";
import "../assets/vendors/css/extensions/dragula.min.css";
import "../assets/css/pages/dashboard-analytics.css";
import "../styles/pipeup-dashboard-theme.css";
import { ShowComments } from "./comments/ShowComments";
import { CommentDetails } from "./commentDetails/CommentDetails";
import { GetTerms } from "./getTerms/GetTerms";
import { AddTerm } from "./addTerm/AddTerm";
import { GetDays } from "./getDays/GetDays";
import { GetFiles } from "./getFiles/GetFiles";
import { AddFile } from "./addFile/AddFile";
import { GetProductFiles } from "./getProductFiles/GetProductFiles";
import { AddProductFile } from "./addProductFile/AddProductFile";
import { EditProduct } from "./editProduct/EditProduct";
import { EditFile } from "./editFile/EditFile";
import { GetUsers } from "./getUsers/GetUsers";
import { GetPayments } from "./getPayments/GetPayments";
import { Menu } from "./menu/Menu";
import { AddTopMenu } from "./addTopMenu/AddTopMenu";
import { AddBottomMenu } from "./addBottomMenu/addBottomMenu";
import { UpdateInformation } from "./updateInformation/UpdateInformation";
import { GetAdminUsers } from "./getAdminUsers/GetAdminUsers";
import { AddDashboardUser } from "./addDashboardUser/AddDashboardUser";
import { PaymentDetails } from "./paymentDetails/PaymentDetails";
import { UserDetails } from "./userDetails/UserDetails";
import { AddProductToUser } from "./addProductToUser/AddProductToUser";
import { EditProductToUser } from "./editProductToUser.js/EditProductToUser";
import { GetContactUS } from "./getContactUS/getContactUS";
import { ContactUSDetails } from "./contactUSDetails/ContactUSDetails";
import { EditTerm } from "./editTerm/EditTerm";
import { AddSubCategory } from "./subCategory/addSubCategory/AddSubCategory";
import { ShowSubCategories } from "./showSubCategories/ShowSubCategories";
import { AddCategory } from "./addCategory/AddCategory";
import { showCategories } from "./showCategories/ShowCategories";
import { AddBrand } from "./addBrand/AddBrand";
import { showBrands } from "./showBrands/ShowBrands";
import { AddType } from "./addType/AddType";
import { showTypes } from "./showTypes/showTypes";
import { GetProducts } from "./getProducts/GetProducts";
import { SupplierPrices } from "./supplierPrices/SupplierPrices";
import BrandDiscounts from "./brandDiscounts/BrandDiscounts";
import { EditSubCategory } from "./editSubCategory/EditSubCategory";
import { EditCategory } from "./editCategory/EditCategory";
import { EditBrand } from "./editBrand/EditBrand";
import { EditType } from "./editType/EditType";
import { GetOrders } from "./getOrders/GetOrders";
import { GetQuotes } from "./getQuotes/GetQuotes";
import { OrderDetails } from "./orderDetails/OrderDetails";
import { AddSlider } from "./addSlider/AddSlider";
import { ShowSlider } from "./showSlider/ShowSlider";
import { GetShopingList } from "./getShopingList/GetShopingList";
import { OpsAlerts } from "../components/opsAlerts/OpsAlerts";
import { StaffManagement } from "./staffManagement/StaffManagement";
import { OwnerSecurity } from "./ownerSecurity/OwnerSecurity";
import { AccessDenied } from "./accessDenied/AccessDenied";
import { MagArticles } from "./mag/MagArticles";
import { MagArticleEdit } from "./mag/MagArticleEdit";
import { MagCategories } from "./mag/MagCategories";
import {
  DashboardRoleProvider,
  useDashboardRole,
} from "../context/dashboardRole";
import { logoutDashboard, staffAllowedPath } from "../utils/dashboardAuth";

const PrivateRoute = ({ component: Component, children, ...rest }) => {
  const [isTokenAvailable, setToken] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    storage
      .load("token")
      .then((res) => {
        if (!res) return Promise.reject();
        setToken(true);
        setLoading(false);
      })
      .catch(() => {
        setToken(false);
        setLoading(false);
      });
  }, []);
  return loading ? null : (
    <Route
      {...rest}
      render={(props) =>
        isTokenAvailable ? (
          <>
            <Component {...props} />
          </>
        ) : (
          <Redirect to="/signIn" />
        )
      }
    >
      {children}
    </Route>
  );
};

const PrivateRoutes = ({ match }) => {
  const { role, loading } = useDashboardRole();
  const location = useLocation();
  if (!loading && role === "staff" && !staffAllowedPath(location.pathname)) {
    return <Redirect to="/dashboard/access-denied" />;
  }
  return (
    <>
      <OpsAlerts />
      <Switch>
        <Route path={match.url} exact={true} component={Home}></Route>
        <Route
          path={match.url + "/staff"}
          exact={true}
          component={StaffManagement}
        />
        <Route
          path={match.url + "/owner-security"}
          exact={true}
          component={OwnerSecurity}
        />
        <Route
          path={match.url + "/mag"}
          exact={true}
          component={MagArticles}
        />
        <Route
          path={match.url + "/mag/categories"}
          exact={true}
          component={MagCategories}
        />
        <Route
          path={match.url + "/mag/new"}
          exact={true}
          component={MagArticleEdit}
        />
        <Route
          path={match.url + "/mag/edit/:id"}
          exact={true}
          component={MagArticleEdit}
        />
        <Route
          path={match.url + "/access-denied"}
          exact={true}
          component={AccessDenied}
        />
        {/* <Route
          path={match.url + "/addProduct"}
          exact={true}
          component={AddProduct}
        /> */}
        <Route
          path={match.url + "/editProduct/:id"}
          exact={true}
          component={EditProduct}
        />
        <Route
          path={match.url + "/editType/:id"}
          exact={true}
          component={EditType}
        />
        <Route
          path={match.url + "/editBrnad/:id"}
          exact={true}
          component={EditBrand}
        />
        <Route
          path={match.url + "/editSubCategory/:id"}
          exact={true}
          component={EditSubCategory}
        />
        <Route
          path={match.url + "/editCategory/:id"}
          exact={true}
          component={EditCategory}
        />
        <Route
          path={match.url + "/showProducts"}
          exact={true}
          component={ShowProducts}
        />
        <Route
          path={match.url + "/addTerm/:id"}
          exact={true}
          component={AddTerm}
        />
        <Route
          path={match.url + "/editTerm/:term_id/term/:product_id"}
          exact={true}
          component={EditTerm}
        />
        <Route
          path={match.url + "/terms/:id"}
          exact={true}
          component={GetTerms}
        />
        <Route
          path={match.url + "/addFile/:id"}
          exact={true}
          component={AddProductFile}
        />
        <Route
          path={match.url + "/files/:id"}
          exact={true}
          component={GetProductFiles}
        />
        <Route
          path={match.url + "/days/:term_id/terms/:product_id"}
          exact={true}
          component={GetDays}
        />
        <Route
          path={match.url + "/files/:day_id/days/:term_id/terms/:product_id"}
          exact={true}
          component={GetFiles}
        />
        <Route
          path={match.url + "/addFile/:day_id/days/:term_id/terms/:product_id"}
          exact={true}
          component={AddFile}
        />
        <Route
          path={match.url + "/editFile/:day_id/days/:term_id/terms/:product_id"}
          exact={true}
          component={EditFile}
        />
        <Route
          path={match.url + "/showComments"}
          exact={true}
          component={ShowComments}
        />
        <Route
          path={match.url + "/commentDetails/:id"}
          exact={true}
          component={CommentDetails}
        />
        <Route
          path={match.url + "/getUsers"}
          exact={true}
          component={GetUsers}
        />
        <Route
          path={match.url + "/getPayments"}
          exact={true}
          component={GetPayments}
        />
        <Route path={match.url + "/menu"} exact={true} component={Menu} />
        <Route
          path={match.url + "/addTopMenu"}
          exact={true}
          component={AddTopMenu}
        />
        <Route
          path={match.url + "/addBottomMenu"}
          exact={true}
          component={AddBottomMenu}
        />
        <Route
          path={match.url + "/updateInformation"}
          exact={true}
          component={UpdateInformation}
        />
        <Route
          path={match.url + "/getAdminUsers"}
          exact={true}
          component={GetAdminUsers}
        />
        <Route
          path={match.url + "/addDashboardUser"}
          exact={true}
          component={AddDashboardUser}
        />
        <Route
          path={match.url + "/paymentDetails/:id"}
          exact={true}
          component={PaymentDetails}
        />
        <Route
          path={match.url + "/userDetails/:id"}
          exact={true}
          component={UserDetails}
        />
        <Route
          path={match.url + "/userDetails/:id/addProductToUser"}
          exact={true}
          component={AddProductToUser}
        />
        <Route
          path={
            match.url + "/userDetails/:user_id/editProductToUser/:product_id"
          }
          exact={true}
          component={EditProductToUser}
        />
        <Route
          path={match.url + "/getContactUS"}
          exact={true}
          component={GetContactUS}
        />
        <Route
          path={match.url + "/contactUSDetails/:id"}
          exact={true}
          component={ContactUSDetails}
        />
        <Route
          path={match.url + "/addSubCategory"}
          exact={true}
          component={AddSubCategory}
        />
        <Route
          path={match.url + "/addSlider"}
          exact={true}
          component={AddSlider}
        />
        <Route
          path={match.url + "/showSubCategories"}
          exact={true}
          component={ShowSubCategories}
        />
        <Route
          path={match.url + "/showSlider"}
          exact={true}
          component={ShowSlider}
        />
        <Route
          path={match.url + "/addCategory"}
          exact={true}
          component={AddCategory}
        />
        <Route
          path={match.url + "/showCategories"}
          exact={true}
          component={showCategories}
        />
        <Route
          path={match.url + "/addBrand"}
          exact={true}
          component={AddBrand}
        />
        <Route
          path={match.url + "/showBrands"}
          exact={true}
          component={showBrands}
        />
        <Route path={match.url + "/addType"} exact={true} component={AddType} />
        <Route
          path={match.url + "/showTypes"}
          exact={true}
          component={showTypes}
        />
        <Route
          path={match.url + "/addProduct"}
          exact={true}
          component={AddProduct}
        />
        <Route
          path={match.url + "/getProducts"}
          exact={true}
          component={GetProducts}
        />
        <Route
          path={match.url + "/supplier-prices"}
          exact={true}
          component={SupplierPrices}
        />
        <Route
          path={match.url + "/brand-discounts"}
          exact={true}
          component={BrandDiscounts}
        />
        <Route
          path={match.url + "/getShopingList"}
          exact={true}
          component={GetShopingList}
        />
        <Route
          path={match.url + "/orderDetails/:id"}
          exact={true}
          component={OrderDetails}
        />
        <Route
          path={match.url + "/getOrders"}
          exact={true}
          component={GetOrders}
        />
        <Route
          path={match.url + "/getQuotes"}
          exact={true}
          component={GetQuotes}
        />
      </Switch>
    </>
  );
};

const ScreensInner = () => {
  let {} = useAppContext();
  const { role } = useDashboardRole();
  const isOwner = role === "owner";
  const isStaff = role === "staff";

  return (
    <>
      {/* <!-- BEGIN: Header--> */}
      <Route path="/signIn" component={SignIn} />
      <div className="puDash">
      <div class="header-navbar-shadow"></div>
      <nav class="header-navbar main-header-navbar navbar-expand-lg navbar navbar-with-menu fixed-top ">
        <div class="navbar-wrapper">
          <div class="navbar-container content">
            <div class="navbar-collapse" id="navbar-mobile">
              <div class="mr-auto float-left bookmark-wrapper d-flex align-items-center">
                <ul class="nav navbar-nav">
                  <li class="nav-item mobile-menu d-xl-none mr-auto">
                    <a
                      class="nav-link nav-menu-main menu-toggle hidden-xs"
                      href="#"
                    >
                      <i class="ficon bx bx-menu"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <ul class="nav navbar-nav float-right">
                <li class="dropdown dropdown-user nav-item">
                  <a
                    class="dropdown-toggle nav-link dropdown-user-link"
                    href="#"
                    data-toggle="dropdown"
                  >
                    <div class="user-nav d-sm-flex d-none">
                      <span class="user-name">ادمین</span>
                      <span class="user-status text-muted">پایپ آپ</span>
                    </div>
                    <span>
                      <img
                        class="round"
                        src="/pipeup-dashboard-admin-avatar.jpg"
                        alt="PipeUp"
                        height="40"
                        width="40"
                        style={{ objectFit: "contain" }}
                      />
                    </span>
                  </a>
                  <div class="dropdown-menu pb-0">
                    {/* <a class="dropdown-item" href="page-user-profile.html">
                      <i class="bx bx-user mr-50"></i> ویرایش پروفایل
                    </a>
                    <a class="dropdown-item" href="app-email.html">
                      <i class="bx bx-envelope mr-50"></i> صندوق ورودی من
                    </a>
                    <a class="dropdown-item" href="app-todo.html">
                      <i class="bx bx-check-square mr-50"></i> وظیفه
                    </a>
                    <a class="dropdown-item" href="app-chat.html">
                      <i class="bx bx-message mr-50"></i> گفتگو ها
                    </a> */}
                    <div class="dropdown-divider mb-0"></div>
                    <a
                      class="dropdown-item"
                      href="#logout"
                      onClick={(e) => {
                        e.preventDefault();
                        logoutDashboard().then(() => {
                          window.location.href = "/signIn";
                        });
                      }}
                    >
                      <i class="bx bx-power-off mr-50"></i> خروج
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
      {/* <!-- END: Header--> */}

      {/* <!-- BEGIN: Main Menu--> */}
      <div
        class="main-menu menu-fixed menu-light menu-accordion menu-shadow"
        data-scroll-to-active="true"
      >
        <div class="navbar-header">
          <ul class="nav navbar-nav flex-row">
            <li class="nav-item mr-auto">
              <Link class="navbar-brand" to="/dashboard">
                <div class="brand-logo">
                  <img
                    class="logo"
                    src="/pipeup-dashboard-brand-logo.png"
                    alt="PipeUp"
                    width="36"
                    height="36"
                  />
                </div>
                <h2 class="brand-text mb-0">پایپ‌آپ</h2>
              </Link>
            </li>
            <li class="nav-item nav-toggle">
              <a class="nav-link modern-nav-toggle pr-0" data-toggle="collapse">
                <i class="bx bx-x d-block d-xl-none font-medium-4 primary"></i>
                <i
                  class="toggle-icon bx bx-disc font-medium-4 d-none d-xl-block primary"
                  data-ticon="bx-disc"
                ></i>
              </a>
            </li>
          </ul>
        </div>
        <div class="shadow-bottom"></div>
        <div class="main-menu-content">
          <ul
            class="navigation navigation-main"
            id="main-menu-navigation"
            data-menu="menu-navigation"
            data-icon-style="lines"
          >
            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                <span class="menu-title" data-i18n="Authentication">
                  داشبورد
                </span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to={isStaff ? "/dashboard/getOrders" : "/dashboard"}>
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Login">
                      {isStaff ? "سفارشات" : "داشبورد اصلی"}
                    </span>
                  </Link>
                </li>
              </ul>
            </li>

            {isOwner ? (
            <>
            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="notebook"></i>
                <span class="menu-title" data-i18n="Authentication">
                  پایپ‌مگ
                </span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to="/dashboard/mag">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item">مقالات</span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/mag/new">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item">مقاله جدید</span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/mag/categories">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item">دسته‌بندی‌ها</span>
                  </Link>
                </li>
              </ul>
            </li>

            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                <span class="menu-title" data-i18n="Authentication">
                  اسلایدر
                </span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to="/dashboard/addSlider">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Login">
                      افزودن
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/showSlider">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه اسلایدرها
                    </span>
                  </Link>
                </li>
              </ul>
            </li>

            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                <span class="menu-title" data-i18n="Authentication">
                  دسته بندی اصلی
                </span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to="/dashboard/addSubCategory">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Login">
                      افزودن
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/showSubCategories">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه دسته بندی اصلی ها
                    </span>
                  </Link>
                </li>
              </ul>
            </li>

            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                <span class="menu-title" data-i18n="Authentication">
                  دسته بندی
                </span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to="/dashboard/addCategory">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Login">
                      افزودن
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/showCategories">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه دسته بندی ها
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                <span class="menu-title" data-i18n="Authentication">
                  برند ها
                </span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to="/dashboard/addBrand">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Login">
                      افزودن
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/showBrands">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه برند ها
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                <span class="menu-title" data-i18n="Authentication">
                  نوع ها
                </span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to="/dashboard/addType">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Login">
                      افزودن
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/showTypes">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه نوع ها
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                <span class="menu-title" data-i18n="Authentication">
                  محصولات
                </span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to="/dashboard/addProduct">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Login">
                      افزودن
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/getProducts">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه محصولات
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/supplier-prices">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="SupplierPrices">
                      به‌روزرسانی قیمت از لیست
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/brand-discounts">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="BrandDiscounts">
                      مدیریت تخفیف برندها
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
            </>
            ) : null}
            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                <span class="menu-title" data-i18n="Authentication">
                  سفارشات
                </span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to="/dashboard/getOrders">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Login">
                      سفارشات
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/getQuotes">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Quotes">
                      درخواست‌های قیمت
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/getShopingList">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="ShoppingList">
                      لیست خرید
                    </span>
                  </Link>
                </li>

                {/* <li>
                  <Link to="/dashboard/showProducts">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Register">
                      همه محصولات
                    </span>
                  </Link>
                </li> */}
              </ul>
            </li>
            {isOwner ? (
            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                <span class="menu-title" data-i18n="Authentication">
                  تماس با ما
                </span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to="/dashboard/getContactUS">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Login">
                      تماس با ما
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
            ) : null}

            {isOwner ? (
            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                <span class="menu-title" data-i18n="Authentication">
                  تراکنش ها
                </span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to="/dashboard/getPayments">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Login">
                      همه تراکنش ها
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
            ) : null}
            {isOwner ? (
            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                <span class="menu-title" data-i18n="Authentication">
                  کاربران
                </span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to="/dashboard/getUsers">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item" data-i18n="Login">
                      مدیریت کاربران
                    </span>
                  </Link>
                </li>
              </ul>
            </li>
            ) : null}
            {isOwner ? (
            <li class=" nav-item">
              <a>
                <i class="menu-livicon" data-icon="thumbnails-big"></i>
                <span class="menu-title">دسترسی و امنیت</span>
              </a>
              <ul class="menu-content">
                <li>
                  <Link to="/dashboard/staff">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item">مدیریت کارکنان</span>
                  </Link>
                </li>
                <li>
                  <Link to="/dashboard/owner-security">
                    <i class="bx bx-left-arrow-alt"></i>
                    <span class="menu-item">احراز دو مرحله‌ای مالک</span>
                  </Link>
                </li>
              </ul>
            </li>
            ) : null}
          </ul>
        </div>
      </div>
      {/* <!-- END: Main Menu--> */}
      <div class="app-content content">
        <div class="content-overlay"></div>
        <div class="content-wrapper">
          <div class="content-header row"></div>
          <div class="content-body">
            <Switch>
              <PrivateRoute path="/dashboard" component={PrivateRoutes} />
              <Route path="*">
                <Redirect to="/signIn" />
              </Route>
            </Switch>
          </div>
        </div>
      </div>
      </div>
    </>
  );
};

const Screens = () => (
  <DashboardRoleProvider>
    <ScreensInner />
  </DashboardRoleProvider>
);

export default Screens;
